module.exports = __webpack_public_path__ + "static/media/11-2.94b4500b.mp3";